import { hot } from "react-hot-loader/root";
import React, { useState } from "react";

const QuestionContent = ({ question, questionIndex, type, onInputClick }) => {
  if (type === "lead") {
    return (
      <>
        <header>
          <h3>
            <span className="index">{questionIndex + 1}</span> Coordonnées
          </h3>
          {question.info !== "" && <p>{question.info}</p>}
        </header>
        <div className="question-content-wrapper">
          <div className="fields half">
            <div className="field">
              <input
                required
                type="text"
                name="first_name"
                placeholder="Prénom*"
              />
            </div>
            <div className="field">
              <input required type="text" name="last_name" placeholder="Nom*" />
            </div>
          </div>
          <div className="fields half">
            <div className="field">
              <input
                required
                type="text"
                name="company"
                placeholder="Entreprise*"
              />
            </div>
            <div className="field">
              <input type="text" name="position" placeholder="Poste occupé" />
            </div>
          </div>
          <div className="fields half">
            <div className="field">
              <input type="text" name="phone" placeholder="Téléphone" />
            </div>
            <div className="field">
              <input required type="email" name="email" placeholder="E-mail*" />
            </div>
          </div>
          <div className="fields">
            <div className="field">
              <label htmlFor="email_cc">Envoyer une copie à l'adresse :</label>
              <input
                type="email"
                name="email_cc"
                placeholder="E-mail en copie"
                className="half-field"
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  const inputType = question.multiple ? "checkbox" : "radio";

  return (
    <>
      <header>
        <h3>
          <span className="index">{questionIndex + 1}</span> {question.question}
        </h3>
        {question.info !== "" && <p>{question.info}</p>}
      </header>
      <div className="question-content-wrapper">
        <ul className="answers">
          {question.answers.map((answer, answerIndex) => (
            <li key={`question${questionIndex}Answer${answerIndex}`}>
              <input
                type={inputType}
                id={`question${questionIndex}Answer${answerIndex}`}
                name={`q${questionIndex}`}
                value={answerIndex}
                required={!question.multiple}
                onChange={onInputClick}
              />
              <label htmlFor={`question${questionIndex}Answer${answerIndex}`}>
                {answer.text}
              </label>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

const Question = ({
  question,
  current,
  q,
  total,
  onNextClick,
  onPrevClick,
  onSubmitClick,
  first,
  last,
}) => {
  const [hasAnswer, setHasAnswer] = useState(false);

  const onInputClick = (e) => {
    // Required question: disable next button if no answer clicked yet.
    if (!question.multiple) {
      setHasAnswer(true);
    }
  };

  const nextButtonDisabled = !question.multiple && !hasAnswer;

  return (
    <div
      className={`single-question${current ? " current" : " "} ${
        question.type ? question.type : "question"
      }`}
    >
      <QuestionContent
        question={question}
        type={question.type ?? "question"}
        questionIndex={q}
        onInputClick={onInputClick}
      />

      <nav className="buttons">
        <span
          className={`button button-prev ${first && "disabled"}`}
          onClick={onPrevClick}
        >
          Précédent
        </span>
        <span className="tracker">
          {q + 1} / {total}
        </span>
        {!last && (
          <span
            className={`button button-next ${nextButtonDisabled && "disabled"}`}
            onClick={onNextClick}
          >
            Suivant
          </span>
        )}
        {last && (
          <button className="button button-submit" type="submit">
            Envoyer
          </button>
        )}
      </nav>
    </div>
  );
};

export default hot(Question);
